import { IAccordion } from '../../components/Accordion/interfaces';
import { ICardHoverProps } from '../../components/DeliveryTypes/interfaces';
import { IDoc } from '../../components/Doc/interfaces';
import { IStep } from '../../components/Steps/interfaces';
import { EnumUrlsPages } from '../../services/Enum';

export const StepsList: IStep[] = [
  { title: 'Вы подготавливаете сопроводительные документы вместе с заказами' },
  { title: 'Мы забираем заказы вместе с документами в назначенное время' },
  {
    title:
      'Доставляем заказ, получатель принимает и ставит необходимые отметки в сопроводительных документах',
  },
  { title: 'Мы возвращаем Вам оригиналы документов по согласованному графику' },
];

export const TariffsList = [
  `<ul>
    <li>100 р. за возврат сопроводительных документов</li>
    <li>Возвращаем документы в следующий забор или по согласованному графику</li>
    <li>Принимаем образцы заполнения для удобства получателей и избежания ошибок</li>
    <li>Промаркируем документы штрих-кодами при необходимости</li>
  </ul>`,
];

export const CategoryList1 = [
  'Одежда, обувь',
  'Автотовары, зачасти',
  'Товары для офиса, канцелярия',
  'Бижутерия, украшения',
  'Товары для туризма и отдыха',
  'Товары народного потребления',
  'Косметика, парфюмерия',
  'Товары для животных',
  'Товары для взрослых',
];

export const CategoryList2 = [
  'Спортивные товары',
  'Рукоделие и творчество, DIY',
  'Музыкальные инструменты',
  'Телефоны, электроника',
  'Товары для дома',
  'Детская одежда, игрушки',
  'Сувениры, подарки',
  'Медицинские товары, БАДы',
  'Игры, развлечения',
];

export const ListDocs: IDoc[] = [
  {
    name: 'Образец договора.pdf',
    size: '287 кб',
    date: '25 сентября 2020',
    type: 'pdf',
    fileUrl: '/docs/returnDocs/dogovor.pdf',
  },
  {
    name: 'Регламент работы.pdf',
    size: '173 кб',
    date: '25 сентября 2020',
    type: 'pdf',
    fileUrl: '/docs/returnDocs/reglament.pdf',
  },
  {
    name: 'Образец отчета агента СПб.pdf',
    size: '125 кб',
    date: '09 октября 2023',
    type: 'pdf',
    fileUrl: '/docs/returnDocs/spb_otchet_09.10.2023.pdf',
  },
  {
    name: 'Образец отчета агента Мск.pdf',
    size: '115 кб',
    date: '09 октября 2023',
    type: 'pdf',
    fileUrl: '/docs/returnDocs/msk_otchet_09.10.2023.pdf',
  },
];

export const ListQuestions: IAccordion[] = [
  {
    title: `Есть ли у вас расчетно-кассовое обслуживание?`,
    content: `Все расчеты ведутся по установленным законодательством требованиям. На данный момент все работы ведутся согласно внесенным изменениям в №54-ФЗ и иным распорядительным документам, регламентирующим финансовую деятельность.`,
  },
  {
    title: `Работаете ли вы с физическими лицами?`,
    content: `К сожалению, на сегодня наша служба доставки работает только с юридическими лицами на основе заключенного договора.`,
  },
  {
    title: `Как часто вы производите перевод платежей?`,
    content: `Перевод денежных средств на стандартных условиях происходит еженедельно. В некоторых случаях мы готовы предложить иные выгодные предложения, вплоть до ежедневных переводов денег.`,
  },
  {
    title: 'Есть ли у вас примерка, частичный выкуп?',
    content: `Да, в договоре по оказанию услуг доставки может входить личная примерка и выкуп лишь части заказа.`,
  },
  {
    title: 'Вы осуществляете забор продукции напрямую от поставщиков?',
    content: `Да, мы работаем с поставщиками и можем забирать заказы напрямую от них, как в рамках «Первой мили», так и по услугам из категории «Последняя миля». Отправляем адресату с соблюдением сроков и гарантий.`,
  },
  {
    title: `Как заказчик может получить информацию о сроках доставки?`,
    content: `Заказав доставку, большинство покупателей указывает желаемое время, которое Вы также можете передать нам в онлайн-заявке. Кроме того, мы оповещаем получателей самостоятельно посредством SMS утром. За час до непосредственной обработки и передачи отправления мы связываемся с получателем по телефону и уточняем детали. Поэтому очень важно указание корректного контактного номера.`,
  },
  {
    title: `Что необходимо сделать для начала работы?`,
    content: `Заполните анкету по <a href='https://mrqz.me/606da15cb981a60044f42f10' target='_blank' rel="nofollow">этой ссылке</a>. После её заполнения с вами по e-mail или телефону свяжутся наши менеджеры и подготовят договор. Также можете оставить заявку на обратный звонок.`,
  },
  {
    title: `Есть определенные интервалы и дни, когда осуществляется доставка? Существуют ли дополнительные особенности в выходные?`,
    content: `Работа выстроена с учетом интервалов по 4 часа в полный период с 9:00 до 22:00. В выходные и праздничные дни основной тариф не изменяется и остается без дополнительных наценок.`,
  },
];

export const ListDalli: string[] = [
  'Доставка в срок круглый год, без праздников, выходных, наценок и коэффициентов',
  'Возможность примерки, частичного выкупа, бесплатного ожидания и подъема на этаж',
  'Удобные фиксированные интервалы доставки до 30км от МКАД',
  'Первоклассный сервис, помогающий генерировать больше выручки на 5-15%',
  'Доставка по всей Московской области по единому тарифу от 320 рублей',
  'Поддержка в считанные минуты, по любому вопросу поможем в течение 5-ти минут и быстрее',
  'Быстрый старт сотрудничества, от договора до начала работы менее, чем за 1 час',
  'Готовые интеграции с Вашей CMS, многофункциональные API или Личный кабинет',
];

export const ListServices: ICardHoverProps[] = [
];

export const DescriptionReturn = `<p>Наш приоритет – отправка срочных грузов курьером. Доставка – в кратчайший период. Выверенная логистика охватывает все регионы по России.</p>
<p>Алгоритм действий:</p>
<ul>
<li>Клиент указывает количество и вид документов, пункт получения.</li>
<li>Экспедитор проверяет экземпляры, сверяет их с накладными квитанциями, актами приема-сдачи.</li>
<li>После выгрузки в точке приема проверяется сохранность, качество продукции, соответствие условиям, указанным в договоре.</li>
<li>Организовывается доставка оригиналов документацию отправителю с печатями и подписями, копия отправляется на электронный адрес клиента.</li>
</ul>
<p>Работаем в Москве, Санкт-Петербурге и других регионах России ежедневно, без выходных и праздников.</p>
<h3>Наши преимущества</h3>
<p>Предлагаем различные формы сотрудничества с магазинами. Мы сделали наши тарифы конкурентоспособными и доступными, чтобы обеспечить вы Крупные бренды и компании с большими объемами продаж могут выделить для магазинов отдельный персонал или подключить полноценное выездное обслуживание. Это позволяет самостоятельно управлять качеством поставок, без задержек заказа. Вам не нужно оплачивать расходы на персонал во время сезонных спадов или временного снижения продаж. Оформляйте возврат сопроводительных документов, независимо от объема закупаемой продукции. Эффективно распределяйте свои ресурсы и сокращайте расходы.</p>
<p>Применяем комплексный подход, в собственности – склад, распределительный пункт, <a href="${EnumUrlsPages.cashService}">кассовое обслуживание</a>. Оказываем услуги в полном формате, необходимом для полномасштабной работы и интеграции, гарантируем качество, профессионализм и надежность.</p>
<p>Наша <a href="/">курьерская службы “Dalli”</a> оказывает круглосуточную поддержку. Сотрудники нашего колл-центра готовы проконсультировать вас по профильным вопросам. Персональный менеджер изучит особенности вашего бизнеса, предложит лучшее решение по возврату сопроводительных документов.</p>
`;
